import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns, NewsletterHost } from 'vpl.tas';
import { articleTables } from '../../article-tables';



export const BlogDetailPage = {
    components: {
        ItemEditBtns,
        NewsletterHost
    },
    directives: {
        articleTables
    },
    props: {
        structKey: [String, Number],
    },
    data() {
        return {
            shareObj: false
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        blogDetail() {
            return this.struct[this.structKey].componentData.ITEM;
        }
    },
    methods: {
        share(e) {
            /*
            if(this.shareObj == false){
              this.shareObj = Ya.share2($(e.target).find('.ya-share2')[0], {
                theme: {
                  services: 'vkontakte,odnoklassniki,telegram,twitter,whatsapp,pinterest',
                  size: 'm',
                  colorScheme: "whiteblack",
                  popupPosition: 'inner',
                  useLinks: true,
                  direction: 'horizontal'
                },
                content: {
                    url: window.location.origin + this.blogDetail.DETAIL_PAGE_URL,
                    title: this.blogDetail.NAME,
                    description: this.blogDetail.PREVIEW_TEXT,
                    image: window.location.origin + this.blogDetail.PREVIEW_IMAGE
                }
              });
            }
            */
            let link = $(e.target);
            if (!link.hasClass('is-active')) {
                link.addClass('is-active');
                link.find('.js-share-inner').addClass('is-open');
            } else {
                link.removeClass('is-active');
                link.find('.js-share-inner').removeClass('is-open');
            }

        },
        shareClick(e, type) {
            e.stopPropagation();

            let pageUrl = window.location.origin + window.location.pathname;
            const pageTitle = encodeURIComponent(document.title);

            switch (type) {
                case 'wa':
                    window.open(`https://wa.me/?text=${pageTitle}%20${pageUrl}`, '_blank').focus();
                    break;
                case 'tg':
                    window.open(`https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`, '_blank').focus();
                    break;
                case 'vk':
                    window.open("https://vk.com/share.php?url=" + pageUrl, '_blank').focus();
                    break;
                case 'copy':

                    try {
                        navigator.clipboard.writeText(pageUrl);
                        alert('Ссылка скопирована в буфер обмена');
                    } catch (err) {
                        const textArea = document.createElement('textarea');
                        textArea.value = pageUrl;
                        document.body.appendChild(textArea);
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            alert('Ссылка скопирована в буфер обмена');
                        } catch (err) {
                            alert('Не удалось скопировать ссылку');
                        }

                        document.body.removeChild(textArea);
                    }

                    break;
            }

            // window.open("https://vk.com/share.php?url=" + window.location.origin + window.location.pathname,"sharer","status=0,toolbar=0,width=650,height=500")

        },
        zoom(e) {
            $(e.target).parents('.js-blog-det-slider-wp').find('.swiper-slide-active').find('a').trigger('click');
        }
    },
    mounted() {

        var blogDetailSwiper = new Swiper('.js-blog-det-slider', {
            loop: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 3000
            },
            pagination: {
                el: ".js-blog-det-pag",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".js-blog-det-btn-next",
                prevEl: ".js-blog-det-btn-prev"
            }
        });

    },
    template: `

<section class="blog__detail-wp">
    <div class="container">
        <div class="blog__detail">
            <div v-if="this.blogDetail && this.blogDetail.DATE" class="blog__detail-date">
                <span>{{this.blogDetail.DATE.day}}</span>
                {{this.blogDetail.DATE.month}}
                <span class="blog__detail-date-year">‘{{this.blogDetail.DATE.year}}</span>
            </div>
            <div class="blog__detail-text content">
                <div class="projects__intra-rightside js-blog-det-slider-wp">
                    <div class="projects__intra-rightside-inner">

                        <div v-if="this.blogDetail.GALLERY && this.blogDetail.GALLERY.length" class="swiper projects__intra-slider js-blog-det-slider">
                            <div class="swiper-wrapper">
                                <div v-for="slide in this.blogDetail.GALLERY" :key="slide.BIG" class="swiper-slide">
                                    <a :href="slide.BIG" class="projects__intra-slider-img" data-fancybox="blog-detail">
                                        <img :src="slide.MEDIUM" :alt="this.blogDetail.NAME" :title="this.blogDetail.NAME" loading="lazy">
                                    </a>
                                </div>
                            </div>
                        </div>

                        <a v-if="this.blogDetail.GALLERY && this.blogDetail.GALLERY.length" href="#" @click.prevent="zoom($event)" class="zoom js-blog-det-zoom">
                            <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                        </a>
                        <div v-if="this.blogDetail.GALLERY && this.blogDetail.GALLERY.length" class="slider-arrows">
                            <div class="swiper-button-prev slider-btn js-blog-det-btn-prev">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </div>
                            <div class="swiper-button-next slider-btn js-blog-det-btn-next">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination js-blog-det-pag"></div>
                </div>
                <div v-article-tables v-html="this.blogDetail.TEXT"></div>
            </div>

            <div class="blog__detail-share">
                <div class="product-detail__share js-share" @click="share($event)">
                    <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                    Поделиться
                    <div class="product-detail__share-inner js-share-inner">
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'wa')"
                                title="">
                                <svg class="ico ico-wa" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-wa"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'tg')"
                                title="">
                                <svg class="ico ico-tg" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-tg"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'vk')"
                                title="">
                                <svg class="ico ico-vk" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-vk"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'copy')"
                                title="">
                                <svg class="ico ico-copy" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-copy"></use></svg>
                        </a>
                    </div>
                </div>
            </div>



        </div>

        <!-- SAIT-135: отдельная строка вне колонок даты, статьи и кнопки «Поделиться». -->
        <NewsletterHost :key="blogDetail.ID" source="blog" variant="article" />
    </div>
</section>
    `
}
